export default __webpack_public_path__ + "fe46336.png";